module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-40-12976bedec4cf92ca663b86970f0b420.svg";